import { useEffect, useMemo, useRef } from "react";
import "./css/MeasureField.css";
import { decode } from "he";

export default function MeasureField({
  id,
  name,
  className,
  label,
  value,
  units,
  defaultUnit,
  onChange,
  clearLabel,
  isInvalid,
  error,
  help,
  labelStyle,
  disabled,
  ...props
}) {
  const inputRef = useRef();
  const handleChange = useMemo(
    () => (event) => {
      if (event.target === inputRef.current) {
        if (onChange instanceof Function) {
          onChange(event);
        }
      } else {
        event.stopPropagation();
      }
    },
    [onChange],
  );
  const handleMagnitudChange = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const magnitud = event.target.value;
    inputRef.current.value = {
      ...(value || {}),
      magnitud,
      ...((!value.unidad &&
        defaultUnit &&
        units.length > 0 &&
        units.filter((unit) => unit.codigo === defaultUnit)) ||
        undefined),
    };
    inputRef.current.name = name;
    inputRef.current.dispatchEvent(
      new Event("change", { bubbles: true, cancelable: true, composed: false }),
    );
  };
  const handleUnidadChange = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const unidad = units.find((unit) => unit.codigo === event.target.value);
    inputRef.current.value = {
      ...(value || {}),
      unidad,
    };
    inputRef.current.name = name;
    inputRef.current.dispatchEvent(
      new Event("change", {
        bubbles: true,
        cancelable: true,
        composed: false,
      }),
    );
  };
  const computedAmmount =
    !!value?.magnitud || value?.magnitud === 0 ? value?.magnitud : "";
  const computedClassName = [
    "form-group",
    "measure-field",
    isInvalid ? "has-error" : "",
    ...className.split(" "),
  ]
    .join(" ")
    .trim();
  useEffect(() => {
    const input = inputRef.current;
    const onChange = handleChange;
    if (!!input) {
      input.addEventListener("change", onChange);
      return () => {
        input.removeEventListener("change", onChange);
      };
    }
  }, [handleChange]);
  return (
    <div className={computedClassName}>
      <label for={id} style={labelStyle} className="control-label">
        {label}
      </label>
      <span className="input-group" id={id} ref={inputRef}>
        <input
          id={`${id}_magnitud`}
          name={`${name}.magnitud`}
          className="form-control"
          type="number"
          value={computedAmmount}
          onChange={handleMagnitudChange}
          aria-invalid={isInvalid}
          disabled={disabled}
        />
        <span className="input-group-addon">
          <select
            onInput={handleUnidadChange}
            value={value?.unidad?.codigo || defaultUnit}
            disabled={disabled}
          >
            <option value="">...</option>
            {units instanceof Array &&
              units?.map((unit) => (
                <option value={unit.codigo}>{decode(unit.html)}</option>
              ))}
          </select>
        </span>
      </span>
      {isInvalid && !!error && <span className="help-block">{error}</span>}
    </div>
  );
}

MeasureField.defaultProps = {
  className: "",
  units: [],
  defaultUnit: "",
};
